<template>
  <div class="con" :style="{
    marginTop: mt,
  }">
    <div class="cards-container text-center">
      <swiper :slidesPerView="1" :spaceBetween="10" :centeredSlides="false" :autoplay="false" :pagination="false"
        :navigation="true" :modules="modules" :breakpoints="{
          300: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          568: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        }" class="mySwiper cards d-flex justify-content-between align-items-center gap-3">
        <swiper-slide v-for="(item, index) in data" :key="index">
          <div class="card w-100" @mouseenter="play_promo(`promo_${index}`, item?.promo_video)" @mouseleave="pause_promo(`promo_${index}`, item?.promo_video)">
            <img class="card-img w-100 h-100" :src="item?.cover" :alt="item?.name" />
            <!-- promo video -->
            <video v-if="item?.promo_video" :src="item?.promo_video" preload="auto" :ref="`promo_${index}`" class="hover-video" muted>
              <source :src="item?.promo_video" type="video/mp4">
            </video>
            <div class="footer">
              <h2>
                {{ item?.name }}
              </h2>
              <p>
                {{ item?.description }}
              </p>
              <div class="bottom" :class="{
                'd-flex justify-content-between': !item?.has_subscription,
                'd-flex justify-content-center': item?.has_subscription,
              }">
                <template v-if="!item?.has_subscription">
                  <router-link class="subscribe-btn" :to="{
                    name: 'payment',
                    params: { id: item?.course_id },
                    query: { free: item?.free },
                  }">اشترك الان</router-link>
                  <router-link class="subscribe-btn" :to="{
                    name: 'course_content',
                    params: { id: item?.course_id },
                  }">
                    الدخول
                  </router-link>
                </template>
                <router-link class="subscribe-btn" :to="{
                  name: 'course_content',
                  params: { id: item?.course_id },
                }" v-else>
                  الدخول للكورس
                </router-link>
              </div>
              <div class="w-100" v-if="item?.has_subscription == false && item?.free == false && $store.state.userToken">
                <button v-if="!is_activating" @click="activate_course_by_code(item?.course_id)"
                  class="course-card-footer w-100">
                  تفعيل الكورس بالكود
                </button>
                <button v-else disabled class="course-card-footer w-100">
                  <span class="spinner-border"></span>
                </button>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";

// import { ClShoppingBag01 } from "@kalimahapps/vue-icons";
import axios from "axios";
import Swal from "sweetalert2";
import config from "@/services/config";

export default {
  name: "MyCourseCardsComponent",
  components: {
    Swiper,
    SwiperSlide,
    // ClShoppingBag01,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    mt: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      is_activating: false,
      player: null
    };
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
  methods: {

    play_promo(ref_id, promo) {
      if (promo) {
        this.$refs[ref_id][0].play().then(console.log('video is play')).catch(err => console.log(err)); // Start video playback
        this.$refs[ref_id][0].style.opacity = 1; // Make it visible
      }

    },
    pause_promo(ref_id, promo) {
      if (promo) {
        this.$refs[ref_id][0].pause(); // Pause video playback
        this.$refs[ref_id][0].currentTime = 0; // Reset video to the start
        this.$refs[ref_id][0].style.opacity = 0; // Hide the video
      }
    },
    activate_course_by_code(course_id) {
      Swal.fire({
        title: "اكتب كود تفعيل الكورس",
        input: "text",
        imageUrl: this.data?.cover,
        imageHeight: "200",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "تفعيل",
        cancelButtonText: "الغاء",
        showLoaderOnConfirm: true,
        preConfirm: (login) => {
          if (login == null || login.length == 0) {
            Swal.fire({
              text: "اكتب الكود عشان تعرف تفعل الكورس",
              icon: "warning",
            });
            return;
          }

          this.is_activating = true;
          axios
            .post(
              `${config.basURL}codes/active-course-code`,
              {
                course_id: course_id,
                course_code: login,
              },
              {
                headers: {
                  auth: this.$store.state.userToken,
                },
              }
            )
            .then(() => {
              Swal.fire({
                text: "تم تفعيل الكورس بنجاح هتلاقي الكورس دلوقتي في كورساتي ",
                icon: "success",
              });
              this.$router.push({ name: "user_courses" });
            })
            .catch((err) => {
              console.log(err);
              if (err.response.status == 400) {
                Swal.fire({
                  text: err.response.data.detail,
                  icon: "error",
                });
              } else if (err.response.status == 404) {
                Swal.fire({
                  text: "الكود غلط اكتب الكود الصح ",
                  icon: "error",
                });
              }
              else {
                Swal.fire({
                  text: "حدث خطاء",
                  icon: "error",
                });
              }
            })
            .finally(() => {
              this.is_activating = false;
            });
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    },
  },
};
</script>

<style scoped>
.hover-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
}

.con {
  padding: 0 1rem;
}

.con h2 {
  color: #dad2c5;
  font-size: 2.25rem;
  font-weight: 500;
  margin: 0;
  padding: 0;
}

.swiper {
  height: 100%;
}

.swiper-slide {
  min-width: 300px;
  max-width: 300px;
  text-align: center;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cards-container .cards {
  margin: 0 auto;
  overflow: hidden;
}

.cards-container .cards .card {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 1rem;
  /* min-width: 350px; */
  width: 100%;
  min-height: 475px;
  padding: 0;
  background: transparent;
  overflow: hidden;
  position: relative;
  border: 0;
}

.cards-container .cards .card .card-img {
  height: 475px !important;
  border-radius: 1rem;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.footer {
  position: absolute;
  bottom: -100%;
  background-color: #00000066;
  width: 100%;
  min-height: 40%;
  backdrop-filter: blur(50px);
  transition: bottom 0.3s;
  padding: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
}

.cards-container .cards .card:hover .footer {
  bottom: 0;
  transition: bottom 0.3s;
}

.cards-container .cards .card .footer h2 {
  color: #fff;
  font-size: 1.25rem;
  font-weight: 500;
  margin: 0;
  padding: 0;
}

.cards-container .cards .card .footer p {
  color: #fff;
  font-size: 0.875rem;
  font-weight: 500;
  margin: 0;
  padding: 0;
}

.cards-container .cards .card .footer .bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 0.5rem;
}

.cards-container .cards .card .footer .bottom .subscribe-btn {
  background-color: #2b4239;
  color: #fff;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  width: calc(100% - 30px - 0.5rem);
  min-height: 40px;
  transition: all 0.3s ease-in-out;
}

.cards-container .cards .card .footer .bottom .subscribe-btn:hover {
  background-color: #dad2c5;
  color: #0d0d0d;
  transition: all 0.3s ease-in-out;
}

.cards-container .cards .card .footer .bottom .cart-btn {
  background-color: #fdfac4;
  color: #000000;
  border-radius: 0.5rem;
  width: 40px;
  height: 40px;
  font-size: 1.5rem;
  font-weight: 700;
  border: none;
  transition: all 0.3s ease-in-out;
}

.cards-container .cards .card .footer .bottom .cart-btn:hover {
  background-color: #dad2c5;
  transition: all 0.3s ease-in-out;
}

.course-card-footer {
  all: unset;
  padding: 0.5rem 0;
  text-align: center;
  cursor: pointer;
  background-color: #dad2c5;
  color: #000;
  border-radius: 5px;
}

@media (max-width: 992px) {
  .con {
    margin-top: 0;
  }

  .swiper-slide {
    width: calc(100% / 3) !important;
    min-width: calc(100% / 3) !important;
    max-width: calc(100% / 3) !important;
  }
}

@media (max-width: 768px) {
  .swiper-slide {
    width: 50% !important;
    min-width: 50% !important;
    max-width: 50% !important;
  }
}

@media (max-width: 568px) {
  .swiper-slide {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
  }
}
</style>
